//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import TooltipsMixin from "@Shared/utils/shared-mixins/tooltips-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignAddTemplateDataPage",
  components: {
    MaterialInput
  },
  mixins: [validationMixin, TooltipsMixin],
  props: {
    currentTemplateData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shouldIncludeApplicationId: this.currentTemplateData.isApplicationIdIncluded
    };
  },
  validations: {
    currentTemplateData: {
      name: {
        required
      },
      description: {
        required
      }
    }
  },
  computed: {
    isValid() {
      return !this.$v.$invalid;
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  mounted() {
    this.initTooltips();
  },
  destroyed() {
    this.destroyTooltips();
  },
  methods: {
    updateIsApplicationIdIncluded() {
      this.$emit("update-prefix-appid", this.shouldIncludeApplicationId);
    }
  }
});